import { render, staticRenderFns } from "./WorkflowZoomFile.vue?vue&type=template&id=510d02ee&"
import script from "./WorkflowZoomFile.vue?vue&type=script&lang=js&"
export * from "./WorkflowZoomFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports